import styles from './Input.module.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = ({ onInput, ...props }: InputProps): JSX.Element => {
  return <input {...props} className={styles.input}></input>;
};

export default Input;
